import { Component, Host, h, Element } from '@stencil/core';
import moveSlotChildElementsToLightDom from '../../utils/moveSlotChildElementsToLightDom';

export interface AhaModalBodyDanger extends HTMLAhaModalBodyDangerElement {}

/**
 * Starter component
 * @slot default - Contents of the default slot.
 */
@Component({
  tag: 'aha-modal-body-danger',
  styleUrl: 'aha-modal-body-danger.css',
  shadow: true,
})
export class AhaModalBodyDanger {
  @Element() host!: HTMLAhaModalBodyDangerElement;

  connectedCallback() {
    if (!this.host.slot && this.host.parentElement?.tagName === 'AHA-MODAL') {
      this.host.slot = 'modal-body';
    }
  }

  render() {
    return (
      <Host>
        <aha-modal-body>
          <div id="header">
            <div id="header-text">
              <slot></slot>
              <slot name="subheader"></slot>
            </div>
          </div>
          <div id="content">
            <slot name="content"></slot>
          </div>
        </aha-modal-body>
      </Host>
    );
  }
}
